import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { buildMasterdataHelper } from "./factory";
export const MasterRegionFragment = gql `
  fragment _ on Region {
    id
    status
    name
    nameTranslations {
      locale
      value
    }
    nameShort
    nameShortTranslations {
      locale
      value
    }
    parentRegionId
    parentRegion @client {
      id
      organisation {
        id
        name
      }
    }
    organisation {
      id
      name
    }
  }
`;
export function useRegionHelper() {
    function getRegions() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query MasterRegions {
            regions {
              ${MasterRegionFragment}
            }
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.regions) !== null && _b !== void 0 ? _b : []);
    }
    function getRegionNameShortMapToId() {
        return masterdataEntities.value.reduce((mapping, d) => {
            mapping[d.nameShort] = d.id;
            return mapping;
        }, {});
    }
    const { masterdataEntities, activeEntities, getFromMasterdata, addMissingSelectValue } = buildMasterdataHelper(getRegions);
    return {
        masterRegions: masterdataEntities,
        masterRegionsActive: activeEntities,
        getRegionFromMaster: getFromMasterdata,
        withMissingRegionSelect: addMissingSelectValue,
        getRegionNameShortMapToId
    };
}
